module.exports = __webpack_public_path__ + "img/store-banner.2a0db00d.jpg";